import { Navigate, useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useHtzWorkOrderShowQuery } from "@/services/backend/htz/work-order/api/work-order-api";
import t from "@/lang/lang";
import { Card } from "@/shared/components/ui/card";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";

export function WorkOrderRoute() {
  const { workOrderId } = useParams();
  const {
    data: workOrder,
    isLoading,
    error,
  } = useHtzWorkOrderShowQuery({
    id: workOrderId!,
  });

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!workOrder) {
    return null;
  }

  // This route generally does not show work orders.
  // It merely redirects to the correct sub-route based
  // on the state of the work order.

  switch (workOrder.workOrderState) {
    case FulfillmentState.Planning:
    case FulfillmentState.Zero:
      return <Navigate to={`../planning/${workOrder.id}`} replace />;
    case FulfillmentState.Execution:
      return <Navigate to={`../execution/${workOrder.id}`} replace />;
    case FulfillmentState.Executed:
    case FulfillmentState.PartiallyExecuted:
    case FulfillmentState.Completed:
    case FulfillmentState.Cancelled:
      return <Navigate to={`../completion/${workOrder.id}`} replace />;
    default:
      return null;
  }
}
